<template>
    <div>
        <BoxPaciente
            ref="BoxPaciente"
            :data="data"
        />

        <Buscar
            :data="data"
        />

        <rkm-row
            class="mt-2 mb-2"
        >
            <rkm-col>
                <template>
                    <rkm-button
                        color="info"
                        class="mb-2"
                        @click="imprimirHistorico()"
                        :disabled="!data.model.agendamentos || data.model.agendamentos.length === 0"
                    >
                        Imprimir histórico
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-table
            :fields="fields.tables.agendamento"
            :items="data.model.agendamentosNotSave || data.model.agendamentos"
            ref="Table"
            :tbody-tr-attr="handleRowAttr"
            sort-by="data"
            hide-filters
        >
            <template v-slot:cell(data)="row">
                {{ row.item.data.split("-").reverse().join("/") }}
            </template>

            <template v-slot:cell(incluido)="row">
                {{ examesIncluido(row.item.incluido) }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    :id="uniqueId('show-btn')"
                    @click="$refs.Modal.open(item)"
                    title="Detalhamento"
                    small
                    color="primary"
                >
                    <rkm-icon icon="search" />
                </rkm-button>

                <rkm-button
                    @click="handlePrint(item)"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click="handleEtiquetaPrint(item)"
                    color="warning"
                    class="colorButton"
                    small
                    title="Imprimir etiqueta"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="tags" />
                </rkm-button>

                <rkm-button
                    color="primary"
                    title="Editar"
                    small
                    @click.stop="$emit('handleAlter', item, index)"
                    :disabled="item.pedido || item.fromRegulacao"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    color="warning"
                    title="Cancelar"
                    small
                    @click.stop="handleCancelar(item)"
                    :disabled="item.pedido || item.fromRegulacao"
                >
                    <rkm-icon icon="ban" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(item)"
                    :disabled="item.pedido || item.fromRegulacao"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>

            </template>
        </rkm-table>

        <rkm-row class="mt-2">
            <rkm-col>
                <p class="m-0">
                 Linhas em <span class="warning">amarelo</span> representam exames com urgência.
                </p>
                <p class="m-0">
                    Linhas em <span class="primary">azul</span> representam os agendamentos retroativos.
                </p>
            </rkm-col>
        </rkm-row>

        <Modal
            ref="Modal"
            :data="data"
        />
    </div>
</template>

<script>

// Components.
import Buscar from '@/components/exame-imagem/agendamento-retroativo/tabs/agendados/Form'
import Modal from '@/components/exame-imagem/agendamento-retroativo/tabs/agendados/components/Modal'
import BoxPaciente from '@/components/exame-imagem/agendamento-retroativo/paciente/Index'

// Moment.
import moment from 'moment'

// Filters.
import formats from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

//Enums
import status from '@/enums/exame-imagem/fechamento/status'

// Mixins.
import { repository, error, object, data, stringCase, printExameImagem } from '@/mixins'

export default {
    components:{ Buscar, Modal, BoxPaciente },
    computed:{
        fields() {

            return {
                tables: {
                    agendamento: [
                        { key: 'data', label: 'Data', class: 'col-max', sortable: true },
                        { key: 'agendamentoNumero', label: 'Agendamento', class: 'col-max', sortable: true },
                        { key: 'grupoExameNome', label: 'Grupo de exame', class: 'col-max', sortable: true },
                        { key: 'incluido', label: 'Exames', class: 'col-max', sortable: true },
                        { key: 'unidadeNome', label: 'Unidade executante', class: 'col-max', sortable: true },
                        { key: 'profissionalNome', label: 'Profissional executante', class: 'col-max', sortable: true },
                        { key: 'horaExame', label: 'Horário', class: 'col-min', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center'}
                    ]
                }
            }
        },
    },
    created() {

        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamentoRetroativo'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        }
    },
    data:() => ({
        agendamento: {
            data: null,
            grupoExameId: null,
            grupoExameNome: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            agendamentoId: '',
            unidadeId: null,
            unidadeNome: '',
            unidadeDisabled: false,
            usuarioId: '',
            urgente: false,
            periodo: {
                start: null,
                end: null,
            },
            prestadorId: null,
            prestadorNome: '',
            medicoNome: '',
            medicoId: null,
        },
        isReadOnly: false,
        enums: {
            status
        },
        desabilitaVolta: false,
    }),
    filters: {
        ...formats,
    },
    mixins: [ repository, error, object, data, stringCase, printExameImagem ],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        examesIncluido(item){

            let nomeExames = ''

            if (item) {

                item.forEach(exameNomeIncluido => {

                    if(!nomeExames){

                        nomeExames = exameNomeIncluido.nome
                    } else {

                        nomeExames = nomeExames + ', ' + exameNomeIncluido.nome
                    }
                })
            }

            return nomeExames
        },
        validate() {
            return this.$refs.Form.validate()
        },
        handleCancelar(item) {

            const exames = item.incluido || [];

            const temExamesVinculados = exames.find(m =>
                m.statusId === this.enums.status.REALIZADO ||
                m.statusId === this.enums.status.FALTOU ||
                m.faturamento
            );

            if (temExamesVinculados) {
                this.showValidationNotification(
                    `Não é possível realizar o cancelamento desse agendamento, pois há um ou mais exames realizados,
                        faturados ou com ausência do paciente registrada.`
                );
                return;
            }

            const destroy = async () => {
                this.setLoading()
                this.repositories.agendamento.cancel(item.agendamentoId)
                    .then(() => {

                        const objId = this.data.model.agendamentos.findIndex(obj => obj.agendamentoId == item.agendamentoId)
                        if (objId !== -1) {
                            this.data.model.agendamentos.splice(objId, 1)
                        }

                        if (this.data.model.agendamentosNotSave && this.data.model.agendamentosNotSave.length > 0) {
                            const objIndex = this.data.model.agendamentosNotSave.findIndex(obj => obj.agendamentoId == item.agendamentoId)
                            if (objIndex !== -1) {
                                this.data.model.agendamentosNotSave.splice(objIndex, 1)
                            }
                        }

                        this.showSaveNotification('Agendamento cancelado com sucesso!')

                        this.$emit('loadDays', this.data.model.agendamentos)
                        this.handleBlur()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            this.showCancelConfirmation(`Deseja realmente cancelar este agendamento?`, destroy)
        },
        handleDestroy(item) {

            const exames = item.incluido || [];

            const temExamesVinculados = exames.find(m =>
                m.statusId === this.enums.status.REALIZADO ||
                m.statusId === this.enums.status.FALTOU ||
                m.faturamento
            );

            if (temExamesVinculados) {
                this.showValidationNotification(
                    `Não é possível realizar o exclusão desse agendamento, pois há um ou mais exames realizados,
                        faturados ou com ausência do paciente registrada.`
                );
                return;
            }

            const destroy = async () => {
                this.setLoading()
                this.repositories.agendamento.destroy(item.agendamentoId)
                    .then(() => {
                        const objId = this.data.model.agendamentos.findIndex((obj => obj.agendamentoId == item.agendamentoId))
                        this.data.model.agendamentos.splice(objId, 1)
                        if (this.data.model.agendamentosNotSave && this.data.model.agendamentosNotSave.length > 0) {
                            const objIndex = this.data.model.agendamentosNotSave.findIndex((obj => obj.agendamentoId == item.agendamentoId));
                            this.data.model.agendamentosNotSave.splice(objIndex, 1)
                        }

                        this.showSaveNotification('Agendamento excluído com sucesso!')

                        this.$emit('loadDays', this.data.model.agendamentos)
                        this.handleBlur()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            this.showDeleteConfirmation(`Deseja realmente excluir esse agendamento?<br/>` +
                `Agendamentos excluídos não poderão ser recuperados.`, destroy)
        },
        getCalendar() {

            this.$emit('loadDays', this.data.model.agendamentos)
        },
        handleEtiquetaPrint(item) {

            let etiqueta = {
                pacienteNome: item.pacienteNome,
                agendamentoNumero: item.agendamentoNumero,
                medicoNome: item.medicoNome,
                data: moment(item.date).format('DD/MM/YYYY'),
                unidadeNome: item.unidadeNome,
                examesIncluido: item.incluido,
                dataNascimento: this.data.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
            }

            this.print().etiqueta(etiqueta)
        },
        handlePrint(item) {

            let agendamento = {
                pacienteNome: item.pacienteNome,
                prontuario: this.data.form.paciente.prontuario,
                nomeResponsavel: item.nomeResponsavel,
                dataNascimento: this.data.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
                agendamentoNumero: item.agendamentoNumero,
                medicoNome: item.medicoNome,
                profissionalNome: item.profissionalNome,
                observacao: item.observacao,
                grupoExameNome: item.grupoExameNome,
                data: moment(item.data).format('DD/MM/YYYY'),
                examesIncluido: item.incluido,
                horaExame: item.horaExame,
                unidadeSolicitante: item.unidadeSolicitanteNome,
                logotipo: this.data.form.cliente.logotipo,
                nomePrefeitura: this.data.form.cliente.nome,
                ramoAtividade: this.data.form.cliente.sistema.ramoAtividade.nome,
                mensagemProtocolo: this.data.form.mensagemProtocolo,
                sistemaNome: this.data.form.cliente.sistema.nome,
                sistemaVersao: this.data.form.cliente.sistema.versao,
                usuario: this.data.form.usuario,
                usuarioNomeSocial: this.data.form.usuarioNomeSocial ? this.data.form.usuarioNomeSocial : null,
                urgente: item.urgente,
                unidadeExecutante: item.infraestruturaNome,
                enderecoExecutante: item.infraestruturaEndereco,
                numeroEnderecoExecutante: item.infraestruturaNumero,
                bairroExecutante: item.infraestruturaBairro,
                telefoneExecutante: item.infraestruturaTelefone,
            }

            this.print().agendamento(agendamento)
        },
        handleRowAttr(item, type) {
            if (type === 'row') {

                if (item.retroativo) {
                    return {
                        style: `
                            border-left: 10px solid #007bff;
                            background-color: #007bff17;
                        `
                    }
                } else if (item.urgente) {
                    return {
                        style: `
                            border-left: 10px solid #ffc107;
                            background-color: #ffc10715;
                        `
                    }
                }
            }
        },
        imprimirHistorico(){

            this.setLoading()

            this.repositories.impressao.historicoExame(this.data.form.paciente.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
.warning {
    color: var(--warning);
}
.primary {
    color: var(--primary);
}
.colorButton {
    color: #fff;
}
</style>